import baseApplicationItem from './baseApplicationItem'
import { merge } from 'lodash'

const module = {
  endpoint: 'admin/catalog/product/technicaldetaillabeltype',
  getNew: {
    id: null,
    type: null
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/technicalDetailLabelTypes.js